import React from 'react';
import './brochures.css';

interface BrochuresProps {
    t: (key: string) => string;
}

const Brochures: React.FC<BrochuresProps> = ({t}) => {

    return (
        <div className="brochures__main_wrapper">
            <div className="brochures__inner_wrapper">

                <div className="brochures__headline">
                    {t('tab_brochures_headline')}
                </div>

                <div dangerouslySetInnerHTML={{ __html: t('tab_brochures_paragraph') }} />

            </div>
        </div>
    )

}

export default Brochures;
